export const CLOSE_PANEL = 'at/workSchedule/holidayListPanel/CLOSE_PANEL'
export const HOLIDAYS_LIST_PANEL_SHOWN_SET = 'at/workSchedule/holidayListPanel/HOLIDAYS_LIST_PANEL_SHOWN_SET'
export const REMOVE_ALL_CONFIRMATION_SHOW = 'at/workSchedule/holidayListPanel/REMOVE_ALL_CONFIRMATION_SHOW'
export const REMOVE_ALL_CONFIRMATION_CLOSE = 'at/workSchedule/holidayListPanel/REMOVE_ALL_CONFIRMATION_CLOSE'
export const SELECTED_YEAR_SET = 'at/workSchedule/holidayListPanel/SELECTED_YEAR_SET'
export const LOAD_DATA = 'at/workSchedule/holidayListPanel/LOAD_DATA'
export const LOAD_DATA_SUCCESS = 'at/workSchedule/holidayListPanel/LOAD_DATA_SUCCESS'
export const LOAD_DATA_FAILURE = 'at/workSchedule/holidayListPanel/LOAD_DATA_FAILURE'
export const CHANGE_SORT = 'at/workSchedule/holidayListPanel/CHANGE_SORT'
export const LIST_TRANSFORMED_SET = 'at/workSchedule/holidayListPanel/LIST_TRANSFORMED_SET'
export const IMPORTED_HOLIDAYS_ADD = 'at/workSchedule/holidayListPanel/IMPORTED_HOLIDAYS_ADD'
export const IMPORTED_HOLIDAYS_REMOVE = 'at/workSchedule/holidayListPanel/IMPORTED_HOLIDAYS_REMOVE'

export const LOAD_HOLIDAYS = 'at/workSchedule/holidayListPanel/LOAD_HOLIDAYS'
export const LOAD_HOLIDAYS_SUCCESS = 'at/workSchedule/holidayListPanel/LOAD_HOLIDAYS_SUCCESS'
export const LOAD_HOLIDAYS_FAILURE = 'at/workSchedule/holidayListPanel/LOAD_HOLIDAYS_FAILURE'


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/actionTypes.js